// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import { ConfigProvider } from 'antd';
// import zhCN from 'antd/locale/zh_CN';
// import 'antd/dist/reset.css';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <ConfigProvider>
//       locale={zhCN}
//       theme={{
//         token: {
//           colorPrimary: '#1890ff',
//         },
//       }}
//     </ConfigProvider>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);